import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../../httpClient/serverApi/types/IGetItemsResult';
import { IRemoteRefreshSchedule } from '../../types/IRemoteRefreshSchedule';

// Remote refreshes can be full or incremental
export const RemoteRefreshTypes = {
  Full: 'Full',
  Incremental: 'Incremental'
};

export interface IRemoteRefreshSchedulesResult extends IGetItemsResult {
  schedules: IRemoteRefreshSchedule[];
  expectedRefreshDuration: number;
}

// Given a datasource id, get the remote refresh schedules
export class GetRemoteRefreshSchedulesRequest extends Request<IGetItemsParams, IRemoteRefreshSchedulesResult> {
  constructor(params: IGetItemsParams) {
    super('getRemoteRefreshSchedules', params);
  }
}
